import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Fab from "@mui/material/Fab";
import Typography from "@mui/material/Typography";
import React, { useEffect, useRef, useState } from "react";
import { AddToHomeScreen } from "react-pwa-add-to-homescreen";
import { connect } from "react-redux";
import Catalogus from "../../components/catalogus/Catalogus";
import {
  fetchProductGroupsBySupplier,
  fetchProductsByGroup,
  fetchSuppliers,
  obtainProductInfo,
} from "../../services/assortiment/actions";
import {
  changeProductgroup,
  changeProducts,
  changeSearchTerm,
  changeSubproducts,
  changeSupplier,
  changeUsedSearchTerm,
} from "../../services/currentInformation/actions";
import "./Assortiment.scss";

const usePropChangeEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
    // eslint-disable-next-line
  }, deps);
};

function Assortiment(props) {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [productGroupsBySupplier, setProductGroupsBySupplier] = useState([]);
  const [productsByGroup, setProductsByGroup] = useState([]);
  const [currentSupplier, setCurrentSupplier] = useState(props.currentSupplier);
  const [currentProductgroup, setCurrentProductgroup] = useState(
    props.currentProductgroup
  );
  const [searchQuery, setSearchQuery] = useState(props.searchTerm);
  const [productsFoundByQuery, setProductsFoundByQuery] = useState(
    props.usedSearchTerm
  );

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
    setProductsFoundByQuery(false);
    props.changeUsedSearchTerm(false);
    setSearchQuery("");
    props.changeSearchTerm("");
  };

  useEffect(() => {
    if (props.searchTerm?.length >= 2) {
      obtainProductInfo(
        props.searchTerm,
        props.identifyInfo,
        props.loginSuccesful,
        props.currentLocation,
        props.changeUsedSearchTerm,
        setProductsByGroup
      );
    }
  }, [props.searchTerm]);

  useEffect(() => {
    if (props.currentProductgroup != "") {
      fetchProductsByGroup(
        props.currentLocation.id,
        props.userId,
        props.currentProductgroup,
        setProductsByGroup
      );
    }
  }, [props.currentProductgroup]);

  useEffect(() => {
    const ids = props.productGroupsBySupplier.map((group) => group.id);
    if (props.productGroupsBySupplier.length > 0) {
      if (!ids.includes(props.currentProductgroup)) {
        props.changeProductgroup(props.productGroupsBySupplier[0].id);
      }
    }
  }, [props.productGroupsBySupplier]);

  useEffect(() => {
    if (props.currentSupplier != "") {
      props.fetchProductGroupsBySupplier(
        props.currentLocation.id,
        props.userId,
        props.currentSupplier
      );
    }
  }, [props.currentSupplier]);

  useEffect(() => {
    const ids = props.assortimentSuppliers.map((supplier) => supplier.id);
    if (
      props.assortimentSuppliers.length > 0 &&
      !ids.includes(props.currentSupplier)
    ) {
      props.changeSupplier(props.assortimentSuppliers[0].id);
    }
  }, [props.assortimentSuppliers]);

  useEffect(() => {
    if (!props.usedSearchTerm | (props.searchTerm == "")) {
      props.changeUsedSearchTerm(false);
      props.fetchSuppliers(props.currentLocation.id, props.userId);
      if (currentProductgroup) {
        fetchProductsByGroup(
          props.currentLocation.id,
          props.userId,
          currentProductgroup,
          setProductsByGroup
        );
      }
    }
    // eslint-disable-next-line
  }, [props.usedSearchTerm]);

  useEffect(() => {
    props.fetchSuppliers(props.currentLocation.id, props.userId);
  }, [props.currentLocation.id]);

  const assortimentColumnsTable = [
    { name: "Naam", dataName: "name" },
    { name: "Prijs", dataName: "salesprice" },
    { name: "Gewicht", dataName: "order_weight" },
    { name: "Aantal", dataName: "number", component: "ProductAmountCount" },
    { name: "", dataName: "basketButton", component: "add2basketButton" },
  ];

  return (
    <>
      <AddToHomeScreen
        translate={{
          safariTapShare: "Klik op delen",
          safariAddHomeScreen: "Kies 'Zet op beginscherm'",
          chromiumAddHomeScreen:
            "Klik 'Zet op beginscherm 'in het browser menu",
          chromiumInstall: "Het App Icon kunt u vinden op het beginscherm",
        }}
      />
      {props.currentSupplier && productsByGroup ? (
        <>
          {props.usedSearchTerm ? (
            <Typography style={{ fontWeight: "bold" }}>
              Resultaten voor "{props.searchTerm}"
            </Typography>
          ) : null}
          <Divider />
          <Box sx={{ position: "fixed", bottom: 70, right: 10, zIndex: 50 }}>
            <Fab color="primary" aria-label="filter" onClick={handleOpen}>
              <FilterAltIcon />
            </Fab>
          </Box>

          <Drawer
            anchor={"top"}
            open={open}
            onClose={toggleDrawer("left", false)}
          >
            <Box sx={{ width: "auto", padding: 2 }} role="presentation">
              {props.currentLocation && props.suppliers.length > 1 && (
                <FormControl fullWidth="true">
                  <InputLabel>Leverancier</InputLabel>
                  <Select
                    value={props.currentSupplier}
                    onChange={(e) => {
                      props.changeSupplier(e.target.value);
                      setCurrentSupplier(e.target.value);
                    }}
                  >
                    {props.assortimentSuppliers.map((supplier) => (
                      <MenuItem value={supplier.id}>{supplier.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              {props.currentSupplier &&
                props.productGroupsBySupplier.length > 0 && (
                  <FormControl fullWidth="true">
                    <InputLabel>Productgroep</InputLabel>
                    <Select
                      value={props.currentProductgroup}
                      onChange={(e) => {
                        props.changeProductgroup(e.target.value);
                        setCurrentProductgroup(e.target.value);
                      }}
                    >
                      {props.productGroupsBySupplier.map((productGroup) => (
                        <MenuItem value={productGroup.id}>
                          {productGroup.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
            </Box>
          </Drawer>
          {productsByGroup ? (
            <Catalogus
              data={productsByGroup}
              columnsMapping={assortimentColumnsTable}
              publicAssortiment={false}
            />
          ) : null}
        </>
      ) : (
        <p1>Er zijn geen producten beschikbaar voor deze locatie.</p1>
      )}
    </>
  );
}

function mapStateToProps(state) {
  return {
    userId: state.login.data.user_id,
    currentLocation: state.currentInformation.current_location,
    currentSupplier: state.currentInformation.current_supplier,
    currentProductgroup: state.currentInformation.current_productgroup,
    suppliers: state.login.current_location.suppliers,
    farmers: state.login.data.farmers,
    identifyInfo: state.identify.identifyInfo,
    loginSuccesful: state.login.data.loginSuccesful,
    farmers: state.login.data.farmers,
    usedSearchTerm: state.currentInformation.used_search_term,
    searchTerm: state.currentInformation.search_term,
    assortimentSuppliers: state.assortiment.suppliers,
    productGroupsBySupplier: state.assortiment.product_groups_by_supplier,
  };
}

export default connect(mapStateToProps, {
  changeSupplier,
  changeProductgroup,
  changeSubproducts,
  changeUsedSearchTerm,
  changeProducts,
  changeSearchTerm,
  fetchProductGroupsBySupplier,
  fetchSuppliers,
})(Assortiment);
